import React, { useState } from "react";
import UsersTab from "@/components/admin/UsersTab";
import ExperiencesTab from "@/components/admin/ExperiencesTab";
import SettingsTab from "@/components/admin/SettingsTab";

const TABS = [
  { key: "users", label: "Users" },
  { key: "experiences", label: "Experiences" },
  { key: "settings", label: "Settings" },
];

/**
 * Admin panel shell — sub-header with tabs and a per-tab content slot.
 * Each tab is a self-contained component owning its own data + handlers.
 */
export default function Admin() {
  const [tab, setTab] = useState("users");

  return (
    <div
      className="bg-ivory min-h-screen pt-24 md:pt-28 pb-24"
      data-testid="admin-page"
    >
      <div className="bg-charcoal text-ivory sticky top-16 md:top-20 z-30">
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-5 flex items-baseline justify-between">
          <p className="eyebrow text-brass" data-testid="admin-banner">
            — Admin —
          </p>
          <nav className="flex gap-7" data-testid="admin-tabs">
            {TABS.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                data-testid={`admin-tab-${t.key}`}
                className={`eyebrow link-underline transition-opacity ${
                  tab === t.key ? "opacity-100" : "opacity-60 hover:opacity-100"
                }`}
              >
                {t.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-6 md:px-10 py-10 md:py-14">
        {tab === "users" && <UsersTab />}
        {tab === "experiences" && <ExperiencesTab />}
        {tab === "settings" && <SettingsTab />}
      </div>
    </div>
  );
}
